<template>
    
    <ul :class="props.listClasses">
        <li
            v-for="(item, index) in props.items" :key="index"
            :class="props.listItemClasses"
        >

            <router-link 
                v-if="item.title && item.id" 
                :to="routeFor('detail', {slug: item.title, pk: item.id})" 
                :title="item[$props.hintProp] || item.title"
                class="flex items-center"                
            >
                <component :is="contentComponent"
                    :imageSrc="(item.cover_image) ? item.cover_image.src : ($props.useFallbackImage) ? require('../../assets/images/no-image.png') : ''"
                    :imageAlt="(item.cover_image) ? item.cover_image.title : ''"
                    :imageClasses="$props.contentImageClasses"
                    
                    :title="item.title"
                    :titleClasses="$props.contentTitleClasses"

                    
                    :info="item.info"
                    :noInfo="$props.noInfo"
                    :infoClasses="$props.contentInfoClasses"
                    
                    :abstract="item.abstract"
                    :noAbstract="$props.noAbstract"
                    :abstractClasses="$props.contentAbstractClasses"

                />     
            </router-link>
            <a 
                v-else-if="item.url" 
                :href="item.url" 
                :title="item[$props.hintProp] || item.title"
                class="flex items-center"
            >
                <component :is="contentComponent"
                    :imageSrc="(item.cover_image) ? item.cover_image.src : ($props.useFallbackImage) ? require('../../assets/images/no-image.png') : ''"
                    :imageAlt="(item.cover_image) ? item.cover_image.title : ''"
                    :imageClasses="$props.contentImageClasses"
                    
                    :title="item.title"
                    :titleClasses="$props.contentTitleClasses"

                    
                    :info="item.info"
                    :noInfo="$props.noInfo"
                    :infoClasses="$props.contentInfoClasses"
                    
                    :abstract="item.abstract"
                    :noAbstract="$props.noAbstract"
                    :abstractClasses="$props.contentAbstractClasses"

                />  
            </a>
            <div v-else class="flex items-center">               
                <component :is="contentComponent"
                    :imageSrc="(item.cover_image) ? item.cover_image.src : ($props.useFallbackImage) ? require('../../assets/images/no-image.png') : ''"
                    :imageAlt="(item.cover_image) ? item.cover_image.title : ''"
                    :imageClasses="$props.contentImageClasses"

                    :title="item.title"
                    :titleClasses="$props.contentTitleClasses"
                    
                    :info="item.info"
                    :noInfo="$props.noInfo"
                    :infoClasses="$props.contentInfoClasses"
                    
                    :abstract="item.abstract"
                    :noAbstract="$props.noAbstract"
                    :abstractClasses="$props.contentAbstractClasses"

                />          
            </div>            
        </li>
    </ul>    

    <Paging       
        v-if="props.paging && props.totalItems > props.pageLimit"
        :pageLimit="props.pageLimit"
        :totalItems="props.totalItems"
    />
</template>

<script>
import Paging from './paging'
import ItemContent from './item-content'
import ItemTextContent from './item-text-content'
import ItemImageContent from './item-image-content'
import { routeFor } from '@/helpers'

export default {

    components: {
        Paging,
        ItemContent,
        ItemTextContent,
        ItemImageContent,
    },    
    
    props: {
        listClasses: { type: String, default: '' },
        listItemClasses: { type: String, default: '' },
        contentTitleClasses: { type: String, default: '' },
        contentImageClasses: { type: String, default: '' },
        contentInfoClasses: { type: String, default: '' },
        contentAbstractClasses: { type: String, default: '' },
        
        hintProp: { type: String, default: ''},

        paging: { type: Boolean, default: false },
        totalItems: { type: Number, default: 1000 },
        pageLimit: { type: Number, default: 25 },
        
        items: { type: Object, default: () => ({}) },
        
        noImage: { type: Boolean, default: false },
        imageOnly: { type: Boolean, default: false },

        noAbstract: { type: Boolean, default: false },
        noInfo: { type: Boolean, default: false },

        useFallbackImage : { type: Boolean, default: false},        
    },

    setup(props) {        

        let contentComponent = 'ItemContent'
        if ( props.noImage )
            contentComponent = 'ItemTextContent'
        else if ( props.imageOnly )
            contentComponent = 'ItemImageContent'
        
        return { 
            props,
            routeFor: routeFor,            
            contentComponent
        }

    },
}
</script>